'use es6';

import http from 'hub-http/clients/apiClient';
import formatMediaBridgeObjects, { formatMediaBridgeObjectRecord } from '../formatters/formatMediaBridgeObjects';
const BASE_URL = '/media-bridge/v1/cross-provider';
export const createGetMediaBridgeObjectsPage = ({
  httpClient
}) => query => {
  return httpClient.get(BASE_URL, {
    query: Object.assign({}, query.toJS(), {
      includeHsv: true // returns HS video 2 events as well (objectTypeId: 0-57 which share MB object schema)
    })
  }).then(formatMediaBridgeObjects);
};
export const getMediaBridgeObjectsPage = createGetMediaBridgeObjectsPage({
  httpClient: http
});
export const createGetMediaBridgeObjectsByIds = ({
  httpClient
}) => ids => {
  const query = {
    id: ids
  };
  return httpClient.get(`${BASE_URL}/coordinates?includeHsv=true`, {
    query
  }).then(response => response.map(formatMediaBridgeObjectRecord));
};
export const getMediaBridgeObjectsByIds = createGetMediaBridgeObjectsByIds({
  httpClient: http
});